import styled from 'styled-components'

export const Fallback = styled.div(({ theme }) => ({
  alignItems: 'center',
  border: `${theme.border.size['2']} solid ${theme.colors.gray500}`,
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  overflow: 'hidden',
}))
